import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import languageService from '../../services/language';
import Weather from '../weather';
import './index.css';

export default class Header extends Component {
  componentDidMount() {
    if (location.hash !== '#flights-table') {
      window.scrollTo(0, 0);
    }
  }

  renderContent() {
    const pagesWithMenuItems = this.props.global.pages.filter(page => page.headerMenuPriority);

    pagesWithMenuItems.push({
      headerMenuItem: {
        Ro: 'Info Aeroport',
        En: 'Airport info'
      },
      headerMenuPriority: 2,
      component: 'viewsInfoPublicInfoAeroport',
      path: '/infopublic/info-aeroport'
    });

    const menuItems = pagesWithMenuItems
    .sort((a, b) => a.headerMenuPriority > b.headerMenuPriority)
    .map((page, index) => {
      let separator = null;

      if (index !== pagesWithMenuItems.length - 1) {
        separator = " | ";
      }

      separator = " | ";

      const linkProps = {
        to: page.path,
        className: "nav-item nav-link " + (window.location.pathname === page.path ? 'active' : ''),
        key: `${page.headerMenuItem['Ro']}-${index}`
      };

      let content = null;

      if (page.headerMenuItem && page.headerMenuItem.icon) {
        content = <i className={`fa fa-${page.headerMenuItem.icon}`} />;
      } else {
        content = <span>{page.headerMenuItem[languageService.language]}</span>;
      }

      return (
        <Link {...linkProps}>
          {content}
          <span className="header__separator">{separator}</span>
        </Link>
      );
    });

    return (
      <header>
        <nav className="navbar fixed-top navbar-toggleable-md navbar-dark bg-faded">
          <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup">
            <i className="fa fa-bars" /><span>Menu</span>
          </button>
          <Link className="navbar-brand" to="/">
            <img src={this.props.global.logoUrl} alt="Aeroport Iasi" />
          </Link>
          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="navbar-nav ml-auto">
              {menuItems}
              <div className="header__weather">
                <Weather />
              </div>
              <div className="header__flags">
                <img src="/assets/images/romanian.png" onClick={languageService.romanian} />
                <img src="/assets/images/english.png" onClick={languageService.english} />
              </div>
            </div>
          </div>
        </nav>
      </header>
    );
  }

  render() {
    let rendered = null;

    if (this.props.global) {
      rendered = this.renderContent();
    }

    return rendered;
  }
}



// WEBPACK FOOTER //
// ./src/components/header/index.js